import {percentageGroup} from "../../utils/step.fields.utils";

const step_schema_boat =
    [
        //Vehicle
        {
            key: 'craft_type'
        },
        {
            key: 'boat_material'
        },
        {
            key: 'year',
            headline: 'boat',
            percentage_group: percentageGroup.PERCENTAGE_BOAT
        },
        {
            key: 'value',
            label: 'Boat Value',
            headline: 'boat',
            percentage_group: percentageGroup.PERCENTAGE_BOAT
        },
        {
            key: 'kept_ashore'
        },
        {
            key: 'claims_or_accidents'
        },
        {
            key: 'years_experience'
        },
        {
            key: 'ncb_years_boat'
        },
        {
            key: 'driver_details',
            info: 'Details',
            extra_children: [
                {
                    key: 'title',
                    variant: 'inline'
                },
                {key: 'first_name'},
                {key: 'last_name'}
            ]
        },
        {
            key: 'telephone',
        },
        {
            key: 'email',
        },
        {
            key: 'date_of_birth',
        },
        {
            key: 'postcode',
        },
        {
            key: 'address1',
            skip_question: true,
        },
        {
            key: 'address2',
            skip_question: true,
        },
        {
            key: 'address3',
            skip_question: true,
        },
        {
            key: 'address4',
            skip_question: true,
        },
        {
            key: 'city',
            skip_question: true,
        },
        {
            key: 'cover_date',
        },
        {
            key: 'marketing',
            extra_children: [
                {key: 'marketing_phone'},
                {key: 'marketing_email'},
                {key: 'marketing_sms'},
            ],
        },
        {
            key: 'end',
        },
    ];
export default step_schema_boat;
